import i18n from "../../i18n";
import Cookies from "js-cookie";

const SET_LOCALE = 'SET_LOCALE';

const state = () => ({
    selected: window.tebex.application.locale,
    available: window.tebex.application.locales,
    fallback: window.tebex.application.fallbackLocale,
});

const getters = {};

const actions = {
    changeLocale ({ commit }, locale) {
        commit(SET_LOCALE, locale);
        i18n.locale = locale;
        Cookies.set("locale", locale, { expires: 365 });
    }
};

const mutations = {
    [SET_LOCALE]: (state, locale) => {
        state.selected = locale;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
